import { useCallback, useRef } from 'react';
const round = (value, precision = 2) => {
  return value.toFixed(precision);
};
export const useMeasurePerformance = () => {
  const startTime = useRef(performance.now());
  const getDuration = useCallback(() => {
    const endTime = performance.now();
    const durationMs = endTime - startTime.current;
    return {
      startTime: round(startTime.current),
      endTime: round(endTime),
      durationMs: round(durationMs)
    };
  }, []);
  return {
    getDuration
  };
};